import { useTranslation } from 'react-i18next';

const FamilyBuildingAdoptionInfo = ({ handleSubmit, prevStep, handleChange, formData, isLastStep, nextStep,isSubmitting,error,placeholder,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="step-section">
        <div className="adoption-journey-label">Adoption Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">Are there any states or countries you are focusing on?</h3>
        <div className="mb-3">
          <textarea
            className="win-form-control textarea-control-w-100"
            name="AdoptionCountry"
            rows="5"
            placeholder={placeholder}
            value={formData.AdoptionCountry || ""}
            onChange={handleChange}
          />
        </div>
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
  {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      {isLastStep ? (
        <button className="next-btn" onClick={handleSubmit} disabled={isSubmitting}></button>
      ) : (
        <button className="next-btn" onClick={nextStep}></button>
      )}
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      {isLastStep && (
        <button
          className="win-btn-primary mobile-view mb-3"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {t('healthprofile')}
        </button>
      )}
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingAdoptionInfo;
